declare global {
  interface Window {
    Optanon: any;
  }
}

export const EVENTS_TYPE = ['COOKIE_PREFERENCES'];

// export const COOKIE_PREFERENCES_FALLBACK_URL =
//   'https://www.vodafone.it/portal/Privati/Area-Privacy/La-nostra-informativa?icmp=cbu_web_FOOTER_preferenze-cookie';
export const NEW_COOKIE_PREFERENCES_FALLBACK_URL =
  'https://www.vodafone.it/privati/area-supporto/contratti-aggiornamenti/privacy/web-privacy-policy-cookies.html';

// export const ONCLICK_EVENTS = {
//   COOKIE_PREFERENCES: () => {
//     if (!window.Optanon) {
//       window.open(NEW_COOKIE_PREFERENCES_FALLBACK_URL, '_blank');
//       return;
//     }

//     try {
//       const oneTrustConsentSdk = document.querySelector('#onetrust-consent-sdk');

//       if (oneTrustConsentSdk) {
//         (oneTrustConsentSdk as HTMLElement)?.style?.removeProperty('display');
//         (oneTrustConsentSdk as HTMLElement)?.style?.removeProperty('z-index');
//       }

//       window.Optanon.ToggleInfoDisplay();
//     } catch (e) {
//       console.log(e);
//     }
//   },
// };

export const NEW_ONCLICK_EVENT = {
  COOKIE_PREFERENCES: () => {
    const redirectToFallbackIfNeeded = () => {
      const current = window.location.href;
      const target = new URL(NEW_COOKIE_PREFERENCES_FALLBACK_URL, window.location.origin).href;

      if (current !== target) {
        window.location.href = target;
      }
    };

    try {
      if (
        typeof window !== 'undefined' &&
        (window as any).wa_cmp &&
        typeof (window as any).wa_cmp.showConsentDialog === 'function'
      ) {
        return (window as any).wa_cmp.showConsentDialog();
      } else {
        redirectToFallbackIfNeeded();
      }
    } catch (err) {
      console.error('Error while respawning CMP dialog:', err);
      redirectToFallbackIfNeeded();
    }
  },
};

